import { CheckAgentService, getagentdetails } from "../apiFunction";
import { mapGetters } from "vuex";
import CheckAgentModal from "../components/modals/CheckAgentModal.vue";
import AgentIssue from "../components/modals/AgentIssue.vue";
import VmModal from "../components/modals/VmModal.vue";
import DeviceConnected from "../components/modals/DeviceConnected.vue";
import Spinner from "../components/fixedcomponents/Spinner.vue";

export default {
	computed: {
		...mapGetters("sectionVUEX", {
			uuid: "getUUID",
		}),
	},
	components: {
		Spinner,
		CheckAgentModal,
		VmModal,
		AgentIssue,
		DeviceConnected,
	},
	methods: {
		systemCheckAgent() {
			return new Promise((resolve) => {
				getagentdetails(this.testDetails.attemptNo)
					.then((res) => {
						this.agentdata = res;
						resolve(res.data);
					})
					.catch((err) => {
						console.log(err);
						resolve("err");
					});
			});
		},
		leaveThetest() {
			if (localStorage.getItem("fromCandidate")) {
				window.close("", "_parent", "");
			}
			localStorage.clear();
			this.$router.push({
				path: "/",
				query: {
					uuid: this.uuid,
				},
			});
		},

		nextSelfiePage() {
			this.$router.push({
				path: "/snapshots",
			});
		},
		nextdosanddonts() {
			this.$router.push({
				path: "/dosanddonts",
			});
		},
		goToTypingTest() {
			this.$router.push({
				path: "/typingtest",
			});
		},
		goTocommunicationTest() {
			this.$router.push({
				path: "/communicationtest",
			});
		},
		verifyFunc() {
			this.isLoading = true;
			CheckAgentService(this.testDetails.attemptNo)
				.then(async (res) => {
					this.isLoading = false;
					if (res.data.data.AGENT_CHECK_RESPONSE) {
						let agentRes = await this.systemCheckAgent();
						if (agentRes === "err") {
							this.$bvModal.show("agentmodal");
						} else {
							if (!agentRes.displayCheck) {
								this.$bvModal.show("devdisconected");
							} else if (!agentRes.vmCheck) {
								this.$bvModal.show("vmachine");
							} else if (
								!agentRes.processCheck ||
								!agentRes.agentPermission ||
								!agentRes.driverCheck
							) {
								this.$bvModal.show("someprob");
							} else {
								this.verifyAgent = true;
							}
						}
					} else {
						this.$bvModal.show("extensionmodal");
					}
				})
				.catch(() => {
					this.isLoading = false;
					this.$bvModal.show("extensionmodal");
				});
		},
	},
};
